import http from "@/utils/requset";
export function token(data){
   return  http.post("/token", data, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
}

export function authCode(data){
   return  http.post("/auth/authCode",data, {})
}
export function register(data){
    return  http.post("/register",data, {})
}
export function currentuser(data={}){
    return  http.get("/currentuser",data, {})
}
export function updatePwd(data={}){
    return  http.post("/updatePwd",data, {})
}
export function updateOtherPwd(data={}){
    return  http.post("/updateOtherPwd",data, {})
}
export function deliverAndStore(data={}){
    return  http.get("/deliverAndStore/tools",data, {})
}
export function deliver(data={}){
    return  http.get("/deliver/tools",data, {})
}
export function user(data={}){
    return  http.get("/users",data, {})
}
export function updateUserStatus(data={}){
    return  http.post("/updateStatus",data, {})
}
export function getUserPermission(data={}){
    return  http.post("/userPermission",data, {})
}
export function getDepartment(data={}){
    return  http.get("/getDepartment",data, {})
}
export function setDepartmentPermission(data={}){
    return  http.post("/departPermission",data, {})
}
export function getSynchronous(data={}){
    return  http.get("/synchronous",data, {})
}
export function getProduce(data={}){
    return  http.get("/product/produce",data, {})
}
export function getDeliverOrder(data={}){
    return  http.get("/deliver/orders",data, {})
}
export function getBaseMater(data={}){
    return  http.get("/commodity/goods",data, {})
}

export function getOrderOriginal(data={}){
    return  http.get("/order/original",data, {})
}
export function getOrderCount(data={}){
    return  http.get("/order/orders/count",data, {})
}
export function getOrderOrders(data={}){
    return  http.get("/order/orders",data, {})
}
export function deleteOrderOrders(data={}){
    return  http.delete("/order/orders",data, {})
}

export function getBaseShopList(data={}){
    return  http.get("/base/getBaseShopList",data, {})
}
export function addBaseShopList(data={}){
    return  http.post("/base/addBaseShopList",data, {})
}
export function getStockList(data={}){
    return  http.get("/base/getBaseStockList",data, {})
}
export function getChannel(data={}) {
    return http.get("/base/getChannel", data, {})
}

export function afterActive(data={}){
    return  http.get("/after/active",data, {})
}
export function getPlatform(data={}){
    return  http.get("/after/platform",data, {})
}
export function addPlatform(data={}){
    return  http.post("/after/addPlatform",data, {})
}
export function updatePlatform(data={}){
    return  http.post("/after/updatePlatform",data, {})
}
export function updatePlatformStatus(data={}){
    return  http.post("/after/updatePlatformStatus",data, {})
}
export function getReceipt(data={}){
    return  http.get("/after/receipt",data, {})
}
export function getTimeout_receipt(data={}){
    return  http.get("/after/timeout_receipt",data, {})
}
export function gettimeout_reminder(data={}){
    return  http.get("/after/timeout_reminder",data, {})
}
export function getReceiptInfo(data={}){
    return  http.get("/after/receiptInfo",data, {})
}
export function getReceiptList(data={}){
    return  http.get("/after/getReceipt",data, {})
}
export function addMaintenance(data={}){
    return  http.post("/after/addMaintenance",data, {})
}
export function addMaintenancePc(data={}){
    return  http.post("/after/addMaintenancePc",data, {})
}
export function getRemovalShipmentData(data={}){
    return  http.get("/after/getRemovalShipmentData",data, {})
}
export function importRemovalShipmentData(data={}){
    return  http.post("/after/importRemovalShipmentData",data, {})
}

export function getSignInfo(data={}){
    return  http.get("/after/getSignInfo",data, {})
}

export function resendEmail(data={}){
    return  http.get("/after/resendEmail",data, {})
}
export function addResendEmail(data={}) {
    return http.post("/after/addResendEmail", data, {})
}
export function ZohoCrm(data={}){
    return  http.get("/after/ZohoCrm",data, {})
}
export function deleteZohoCrm(data={}){
    return  http.get("/after/deleteZohoCrm",data, {})
}
export function get_mabang_offline_order(data={}){
    return  http.get("/after/get_mabang_offline_order",data, {})
}
export function get_mabang_order_detail(data={}){
    return  http.get("/after/get_mabang_order_detail",data, {})
}
export function push_kingdee_order(data={}){
    return  http.get("/after/push_kingdee_order",data, {})
}
export function push_saleOrder(data={}){
    return  http.get("/after/push_saleOrder",data, {})
}
export function getReturnList(data={}) {
    return http.get("/after/returnList", data, {})
}
export function getToDoList(data={}) {
    return http.get("/after/toDoList", data, {})
}
export function getSendList(data={}) {
    return http.get("/after/outList", data, {})
}

export function outListPc(data={}) {
    return http.get("/after/outListPc", data, {})
}
export function toDoListPc(data={}) {
    return http.get("/after/toDoListPc", data, {})
}
export function toDoListPcExport(data={}) {
    return http.get("/after/toDoListPcExport", data, {})
}
export function outSend(data={}) {
    return http.post("/after/outSend", data, {})
}
export function outSendDelay(data={}) {
    return http.post("/after/outSendDelay", data, {})
}
export function toDoDelay(data={}) {
    return http.post("/after/toDoDelay", data, {})
}
export function transferList(data={}) {
    return http.get("/after/transferList", data, {})
}
export function transferOut(data={}) {
    return http.post("/after/transferOut", data, {})
}
export function operationLog(data={}){
    return  http.get("/after/operationLog",data, {})
}
export function operationLogItem(data={}){
    return  http.get("/after/operationLogItem",data, {})
}
export function operationLogItems(data={}){
    return  http.get("/after/operationLogItems",data, {})
}
export function getexport_tempInStore(data={}){
    return  http.get("/after/export_tempInStore",data, {})
}
export function tempInStoreMater(data={}){
    return  http.get("/after/tempInStoreMater",data, {})
}
export function tempInStoreCheckRemarks(data={}){
    return  http.get("/after/tempInStoreCheckRemarks",data, {})
}
export function tempInStore(data={}){
    return  http.post("/after/tempInStoreMater",data, {})
}
export function getTempInStore(data={}){
    return  http.get("/after/tempInStore",data, {})
}
export function getTempInStoreTrack(data={}){
    return  http.get("/after/getTempInStoreTrack",data, {})
}
export function addTempInStoreTrack(data={}){
    return  http.post("/after/addTempInStoreTrack",data, {})
}
export function updateTempInStoreTrack(data={}){
    return  http.post("/after/updateTempInStoreTrack",data, {})
}
export function getAllSignAndInstoreLog(data={}){
    return  http.get("/after/getAllSignAndInstoreLog",data, {})
}


export function bestbuy(data={}){
    return  http.get("/bestbuy/bestbuy",data, {})
}
export function getMbNewOrder(data={}){
    return  http.get("/bestbuy/getMbNewOrder",data, {})
}
export function shopify(data={}){
    return  http.get("/bestbuy/getShopify",data, {})
}
export function getStoreList(data={}){
    return  http.get("/bestbuy/getStoreList",data, {})
}
export function addRIIBigStock(data={}){
    return  http.post("/bestbuy/addRIIBigStock",data, {})
}
export function delRIIBigStock(data={}){
    return  http.post("/bestbuy/delRIIBigStock",data, {})
}
export function addRIIModifyUpload(data={}){
    return  http.post("/bestbuy/addRIIModifyUpload",data, {})
}
export function getRIIModifyFile(data={}){
    return  http.get("/bestbuy/getRIIModifyFile",data, {})
}
export function addTeapplix(data={}){
    return  http.post("/bestbuy/addTeapplix",data, {})
}
export function addOutFile(data={}){
    return  http.post("/bestbuy/addOutFile",data, {})
}
export function updateBbyMbErpChannel(data={}){
    return  http.post("/bestbuy/updateBbyMbErpChannel",data, {})
}
export function sendBbyMbErp(data={}){
    return  http.post("/bestbuy/sendBbyMbErp",data, {})
}
export function bestbuyConfig(data={}) {
    return http.get("/bestbuy/bestbuyConfig", data, {})
}
export function bestbuyMater(data={}) {
    return http.get("/bestbuy/bestbuyMater", data, {})
}
export function addbestbuyConfig(data={}) {
    return http.post("/bestbuy/bestbuyConfig", data, {})
}

export function addCopilot(data={}) {
    return http.post("/bestbuy/addCopilot", data, {})
}
export function getShopifyVideo(data={}){
    return  http.get("/resource/getVideoList",data, {})
}
export function getOrderList(data={}){
    return  http.get("/resource/getOrderList",data, {})
}


//查询问题采集http://8.148.209.38:18082
export function getShopifyServerList(currentPage,pageSize,data){
    // return  http.post("/Shopify/getShopifyServer/"+currentPage+'/'+pageSize,data)
    return  http.post("https://dip.sylvoxtv.com/shopifyserver-consume/Shopify/getShopifyServer/"+currentPage+'/'+pageSize,data)
}
//edi
export function pullInvoice(){
    // return  http.get("/invoice/pullInvoice")
    return http.get("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/pullInvoice")
}
export function getEdiList(data={}){
    // return  http.post("/invoice/list",data, {})
    return http.post("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/list",data, {})
}
export function getMailAccountList(){
    // return  http.post("/invoice/mailAccountList")
    return http.post("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/mailAccountList")
}
export function addOrUplMailAccountList(data={}){
    // return  http.post("/invoice/addOrUplMailAccountList",data, {})
    return http.post("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/addOrUplMailAccountList",data, {})
}
export function getInvoiceLineItems(data){
    // return  http.get("/invoice/getInvoiceLineItems/"+data, {})
    return  http.get("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/getInvoiceLineItems/"+data, {})
}
export function addInvoice(data={}){
    // return  http.post("/invoice/addInvoice",data, {})
    return  http.post("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/addInvoice",data, {})
}
export function getAddEdiList(data={}){
    // return  http.post("/invoice/addEdiList",data, {})
    return  http.post("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/addEdiList",data, {})
}
export function previewEdifact(data,state){
    // return  http.get("/invoice/previewEdifact/"+data+"/"+state, {})
    return  http.get("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/previewEdifact/"+data+"/"+state, {})
}
export function addFile(po) {
    // return http.post("/invoice/addFile/"+po, {});
    return http.post("https://dip.sylvoxtv.com/shopifyserver-consume/invoice/addFile/"+po, {});
}
